<rating [(ngModel)]="rate" [max]="max"></rating>
<div class="card">
  <pre class="card-block card-header" style="margin:15px 0;">Rate: <b>{{rate}}</b> </pre>
</div>
